module.exports = __webpack_public_path__ + "static/media/icon_vpp.d38ac8ca.svg";